(function(){
    'use strict';

    angular.module('elogbooks.user.sharing-setup', []);
})();